import { COUNTRY_CODES } from '@app/domain/countries';
import { ACCOUNT_FILED_EXACT_LENGTH } from '@app/domain/uiConsts';

export interface LocalFormat {
  name: string;
  length: number;
}

// Mirrors the server's LocalFormatConfigurations: the one identifier that addresses a domestic account whole.
const LOCAL_FORMATS: Partial<Record<string, LocalFormat>> = {
  [COUNTRY_CODES.Mexico]: { name: 'CLABE', length: ACCOUNT_FILED_EXACT_LENGTH.MX.clabe },
  [COUNTRY_CODES.Argentina]: { name: 'CBU/CVU', length: ACCOUNT_FILED_EXACT_LENGTH.AR.cbu },
};

export function getLocalFormat(countryCode: string | null | undefined): LocalFormat | undefined {
  return countryCode ? LOCAL_FORMATS[countryCode] : undefined;
}

export function localFormatLabel(countryCode: string | null | undefined): string {
  return getLocalFormat(countryCode)?.name ?? 'Local format';
}
